import { stateCodeFromGstin } from './gstSplit';
const STATES = [
    ['01', 'JAMMU AND KASHMIR'],
    ['02', 'HIMACHAL PRADESH'],
    ['03', 'PUNJAB'],
    ['04', 'CHANDIGARH'],
    ['05', 'UTTARAKHAND'],
    ['06', 'HARYANA'],
    ['07', 'DELHI'],
    ['08', 'RAJASTHAN'],
    ['09', 'UTTAR PRADESH'],
    ['10', 'BIHAR'],
    ['11', 'SIKKIM'],
    ['12', 'ARUNACHAL PRADESH'],
    ['13', 'NAGALAND'],
    ['14', 'MANIPUR'],
    ['15', 'MIZORAM'],
    ['16', 'TRIPURA'],
    ['17', 'MEGHALAYA'],
    ['18', 'ASSAM'],
    ['19', 'WEST BENGAL'],
    ['20', 'JHARKHAND'],
    ['21', 'ORISSA'],
    ['22', 'CHHATTISGARH'],
    ['23', 'MADHYA PRADESH'],
    ['24', 'GUJARAT'],
    ['26', 'DADRA AND NAGAR HAVELI & DAMAN AND DIU'],
    ['27', 'MAHARASHTRA'],
    ['29', 'KARNATAKA'],
    ['30', 'GOA'],
    ['31', 'LAKSHADWEEP'],
    ['32', 'KERALA'],
    ['33', 'TAMIL NADU'],
    ['34', 'PUDUCHERRY'],
    ['35', 'ANDAMAN AND NICOBAR'],
    ['36', 'TELANGANA'],
    ['37', 'ANDHRA PRADESH'],
    ['38', 'LADAKH'],
    ['97', 'OTHER TERRITORY'],
    ['99', 'OTHER COUNTRY'],
];
export const GST_STATE_OPTIONS = STATES.map(([code, name]) => ({
    value: code,
    label: `${code}-${name}`,
}));
/** The printable form of a stored code, or null when it is not one we know. */
export const gstStateLabel = (code) => GST_STATE_OPTIONS.find((state) => state.value === code)?.label ?? null;
/**
 * The GST code a free-text state name refers to, or null when it is not one we know.
 *
 * FOR SEEDING PLACE OF SUPPLY FROM A WAREHOUSE ROW, whose `state` column is a name somebody
 * typed ("Haryana"), not a code. Case-insensitive exact match only - "Harya" must not pick a
 * state, for the same reason a half-typed GSTIN must not.
 */
export function gstStateCodeFromStateName(name) {
    const wanted = name?.trim().toUpperCase();
    if (!wanted)
        return null;
    return STATES.find(([, stateName]) => stateName === wanted)?.[0] ?? null;
}
/**
 * The place of supply a GSTIN implies, for seeding a form.
 *
 * A GSTIN CARRIES ITS STATE IN THE FIRST TWO DIGITS, so asking somebody to type the number and
 * then separately pick the state already inside it is how an order ends up with no place of
 * supply — and a document that can only print an undifferentiated "Tax".
 *
 * NULL UNLESS IT IS A STATE WE RECOGNISE. `stateCodeFromGstin` answers "are these two digits",
 * which is true of '00' and '40' as readily as '29'; this answers "are these two digits a real
 * jurisdiction". A half-typed number or a placeholder must not silently set a tax treatment.
 *
 * A SEED, NOT A RULE. Place of supply is legally where the goods are delivered, which for a
 * bill-to/ship-to split across states is not always the state on the GSTIN — so what this
 * returns fills a field somebody can still change, and never decides anything on its own.
 */
export function placeOfSupplyFromGstin(gstin) {
    const code = stateCodeFromGstin(gstin);
    if (!code)
        return null;
    return GST_STATE_OPTIONS.some((state) => state.value === code) ? code : null;
}
//# sourceMappingURL=gstStates.js.map